import { Loader2 } from "lucide-react";

export interface LoadingProps {
  size?: number;
}

export default function Loading({ size = 24 }: LoadingProps) {
  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center">
      <Loader2 className="animate-spin text-primary" size={size} />
    </div>
  );
}
